import React, { useLayoutEffect, useState, useEffect } from 'react';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';
import isInteger from 'lodash/isInteger';
import isEmpty from 'lodash/isEmpty';
import { storesByZip } from '../../api/storeInfoApi';
import {
  trackStoreLocationStoreLocationSet,
  trackViewMoreStoresStoreLocationSet,
  trackStoreLocationZipSearch,
  trackViewMoreStoresZipSearch
} from '../../utils/analytics/trackEvents';
import { analyticConstants } from '../../utils/constants';

export const useIsMobile = () => {
  const [windowWidth, setWindowWidth] = useState([0, 0]);
  useLayoutEffect(() => {
    function updateSize() { setWindowWidth(window.innerWidth); }
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);
  return windowWidth <= 768;
};

export const sortStores = (stores, storeId) => {
  const store = find(stores, (st) => +st.storeId === +storeId);
  if (store) {
    const sortedStores = sortBy(filter(stores, (st) => +st.storeId !== +store.storeId), ['distance']);
    sortedStores.unshift(store);
    return { sortedStores, store };
  }
  return { sortedStores: stores };
};

export const fetchStoresData = async (zip, storeId = 121) => {
  const result = await storesByZip(zip);
  const { recordCount = 0 } = result?.searchReport || {};
  if (recordCount > 0) {
    const { sortedStores, store } = sortStores(result.stores, storeId);
    return ({ recordCount, store, stores: sortedStores });
  }
  return ({ recordCount, store: {}, stores: result.stores });
};

export const updateStoresListByZipcode = (zip, storeId) => {
  let storeResults = {};
  storesByZip(zip).then((result) => {
    if (result) {
      storeResults.recordCount = result.searchReport.recordCount;
      storeResults.stores = sortStores(result.stores, storeId);
    }
  });
  return storeResults;
};

export const responsiveStyles = (isMobile) => ({
  numTilesToShow: isMobile ? 2 : 3,
  tileWidth: isMobile ? '100%' : '30%',
});

export const trackAnalytics = (action, callLocation) => {
  const { fetchStores, setStores, storeClick, viewMoreClick } = analyticConstants;
  if (action === fetchStores && callLocation === storeClick) {
    trackStoreLocationZipSearch();
  } else if (action === fetchStores && callLocation === viewMoreClick) {
    trackViewMoreStoresZipSearch();
  } else if (action === setStores && callLocation === storeClick) {
    trackStoreLocationStoreLocationSet();
  } else if (action === setStores && callLocation === viewMoreClick) {
    trackViewMoreStoresStoreLocationSet();
  }
};